import clsx from "clsx";
import {
  clientAvatarSurfaceStyle,
  clientInitialsFromName,
} from "@/utils/clientAvatarStyles";

/**
 * Deterministic initials-on-tint avatar for a client or mission entity row.
 */
export interface ClientAvatarProps {
  name: string;
  size?: "xs" | "sm" | "md" | "lg";
  className?: string;
}

const SIZE_CLASSES: Record<Required<ClientAvatarProps>["size"], string> = {
  xs: "w-5 h-5 text-[9px] rounded-md",
  sm: "w-9 h-9 text-xs rounded-lg",
  md: "w-12 h-12 text-sm rounded-xl",
  lg: "w-16 h-16 text-lg rounded-2xl",
};

export function ClientAvatar({ name, size = "md", className }: ClientAvatarProps) {
  const initials = clientInitialsFromName(name);
  const { color, style } = clientAvatarSurfaceStyle(name);

  return (
    <span
      className={clsx(
        "flex-shrink-0 flex items-center justify-center font-semibold",
        SIZE_CLASSES[size],
        className,
      )}
      style={{ ...style, color }}
      aria-hidden
    >
      {initials}
    </span>
  );
}
